const chatbotConfig = {
  "/system/chatbot/status.read": {
    protocol: "ws",
    resource: "/system/chatbot/status",
    restful: false,
    method: "read",
    buildParams: () => ({}),
    action: null,
    mockSelector: "chatbot.status",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/chatbot/chat.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/chatbot/chat",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params.data }),
    action: null,
    mockSelector: "chatbot.chat",
  },
  "/orgs/:orgId/sites/:siteId/chatbot/chat.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/chatbot/chat",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params.data }),
    action: null,
    mockSelector: "chatbot.chat",
  },
};

export default chatbotConfig;
